// Matches member positions to the addresses the server looked up for them.

/**
 * A position rounded to 4 decimal places (about 11 m), as the server rounds
 * the fixes it reverse geocodes. Not for display or logs.
 */
export function addressKey(lat: number, lon: number): string {
  return `${Math.round(lat * 10_000)},${Math.round(lon * 10_000)}`;
}

/** A small LRU of addresses by key; null records that there is none. */
export class AddressCache {
  private readonly entries = new Map<string, string | null>();

  constructor(private readonly size = 256) {}

  get(key: string): string | null | undefined {
    const address = this.entries.get(key);
    if (address !== undefined) this.put(key, address);
    return address;
  }

  put(key: string, address: string | null): void {
    this.entries.delete(key);
    this.entries.set(key, address);
    if (this.entries.size > this.size) this.entries.delete(this.entries.keys().next().value!);
  }
}
